module.exports = __webpack_public_path__ + "assets/images/icon-pin-cluster.3a37d244.svg";